export const QUERY_NAME_AUTOSUGGEST_SEARCH = "autosuggestSearch";
export const QUERY_NAME_FCAST_NEARBY = "fcastNearby";
export const QUERY_NAME_LIVECAMS_AND_VIDEOS_NEARBY = "livecamsAndVideosNearby";
export const QUERY_NAME_LIVECAMS_BY_TAGS = "livecamsByTags";
export const QUERY_NAME_LIVECAMS_NEARBY = "livecamsNearby";
export const QUERY_NAME_LIVECAMS_NEARBY_PAGINATED = "livecamsNearbyPaginated";
export const QUERY_NAME_LIVECAM_BY_ID = "livecamById";
export const QUERY_NAME_LOCATION = "location";
export const QUERY_NAME_LOCATION_SUMMARY = "locationSummary";
export const QUERY_NAME_NCAST_NEARBY = "ncastNearby";
export const QUERY_NAME_POLLEN_NEARBY = "pollenNearby";
export const QUERY_NAME_SKI_AREA = "skiArea";
export const QUERY_NAME_SKI_AREA_COUNTRIES = "skiAreaCountries";
export const QUERY_NAME_WARNINGS_NEARBY = "warningsNearby";
export const QUERY_NAME_COMBINED_WEATHER_NEARBY = `combinedWeather_${QUERY_NAME_NCAST_NEARBY}_${QUERY_NAME_FCAST_NEARBY}`;
